import React from 'react';
import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';
import View from './View';
import Edit from './Edit';
import Upload from './Upload';
import Type from './Type';
import Order from './Order';
import Size from './Size';
import Product from './Product';

export default function() {
  const { path, url } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/edit`} component={Edit}/>
      <Route path={`${path}/upload`} component={Upload}/>
      <Route path={`${path}/type`} component={Type}/>
      <Route path={`${path}/order`} component={Order}/>
      <Route path={`${path}/size`} component={Size}/>
      <Route path={`${path}/view`} component={View}/>
      <Route path={`${path}/product`} component={Product}/>
      <Redirect to={`${url}/view`}/>
    </Switch>
  );
}